import React from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as mainMenuActions from '../../../actions/mainMenuActions';
import * as actionTypes from '../../../actions/actionTypes';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import MainMenuItem from './MainMenuItem';
import MainMenuAccordionBtn from './MainMenuAccordionBtn';
import HomeBtn from '../../buttons/HomeButton';
import TextResizeTool from '../../accessibility/TextResize';
import Locale from '../../form/LocalePicker';
import * as objectConstants from '../../../constants/objectConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as localeStorage from '../../../localStorage/localStorage';
import * as navigationConstants from '../../../constants/navigationConstants';
import {TweenLite, Elastic, Bounce, Expo, Linear} from 'gsap';
import _ from 'lodash';
import gsap from 'gsap-react-plugin';

class MainMenu extends React.Component {

    constructor(props, context) {
        super(props, context);

        let bite_id = appHelper.getBiteByScreenId(this.props.trackingData.lesson_location);
        if(!appHelper.isDefined(bite_id)){
            bite_id = localeStorage.contentData.experience.bites[0].bite_id;
        }

        this.state = {
            lang: this.props.lang,
            bite: appHelper.getBiteById(bite_id),
            screens: [],
            setCurrentScreen: false,
            current_screen_id: this.props.trackingData.lesson_location,
            currentFocusedScreenIndex: undefined,
            currentFocusedSubScreenIndex: undefined,
            isDialog: true,
            tabPressed: false,
            shiftPressed: false,
            goToFirst: false,
            goToLast: true,
            accordionBtnPreId: "menuNavAccordionBtn_",
            itemPreId: "menuNavItem_",
            tabbableElements: [],
            doSetTabbableElements: false,
            guid: dataHelper.createGuid(),
            fontSize: this.props.fontSize,
            height: undefined,
            updateHeight: true,
            main_menu_label: appHelper.getLocaleString("main_menu_label"),
            showLocaleTitle: false
        };

        this.setScreenStructure = this.setScreenStructure.bind(this);
        this.getScreenByParentScreenId = this.getScreenByParentScreenId.bind(this);
        this.setMainMenuStatus = this.setMainMenuStatus.bind(this);
        this.setMainMenuAnimation = this.setMainMenuAnimation.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.hideMenu = this.hideMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.getClass = this.getClass.bind(this);
        this.setInitialFocus = this.setInitialFocus.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.setTabbableElements = this.setTabbableElements.bind(this);
        this.setHeight = this.setHeight.bind(this);
        this.getHeight = this.getHeight.bind(this);

        this.mainMenu = React.createRef();
    }

    componentDidMount() {
        window.addEventListener("keydown", this.onKeyDown);
        window.addEventListener("keyup", this.onKeyUp);
        this.setMainMenuAnimation();
        this.setScreenStructure();


    }

    componentWillReceiveProps(nextProps) {
        if (this.state.fontSize !== nextProps.fontSize) {
            this.setState({fontSize: nextProps.fontSize, updateHeight: true});
        }
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                main_menu_label: appHelper.getLocaleString("main_menu_label")
            });
        }
    }

    componentDidUpdate() {
        this.setMainMenuAnimation();

        if (this.state.doSetTabbableElements) {
            this.setTabbableElements();
        }

        if(this.state.updateHeight){
            this.setHeight();
        }

    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.onKeyDown);
        window.removeEventListener("keyup", this.onKeyUp);
    }

    setTabbableElements() {
        let dialog = this.mainMenu.current;
        if(appHelper.isEleDefined(dialog)) {
            let tabbableElements = dataHelper.getAllTabbableElements(dialog);
            this.setState({doSetTabbableElements: false, tabbableElements: Object.assign([], tabbableElements)});
        }
    }

    setInitialFocus() {
        let mainMenuPanel = this.mainMenu.current;
        if(appHelper.isEleDefined(mainMenuPanel)) {
            mainMenuPanel.focus();
        }
    }

    setScreenStructure() {
        //parent_screen_id
        let topLevelScreens = this.getScreenByParentScreenId(null);
        for (let i = 0; i < topLevelScreens.length; i++) {
            let topLevelScreen = topLevelScreens[i];

            let firstChildScreen = Object.assign({}, topLevelScreen);
            let childScreens = this.getScreenByParentScreenId(topLevelScreen.screen_id);
            if (childScreens.length > 0) {
                childScreens = dataHelper.immutableUnshift(childScreens, firstChildScreen);
            }
            topLevelScreen = Object.assign({}, topLevelScreen, {
                hasChildren: childScreens.length > 0,
                childScreens: childScreens
            });

            topLevelScreens = dataHelper.immutableSplice(topLevelScreens, i, 1, topLevelScreen);
        }

        this.setState({
            setCurrentScreen: true,
            screens: Object.assign([], topLevelScreens),
            doSetTabbableElements: true,
        });
    }

    getScreenByParentScreenId(value) {
        let screens = [];

        for (let i = 0; i < this.state.bite.screens.length; i++) {
            let screen = this.state.bite.screens[i];
            if (value === null) {
                if (!appHelper.isDefined(screen.parent_screen_id) || screen.parent_screen_id === value) {
                    if (this.state.bite.show_target_screens_in_menu && screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
                        screens = dataHelper.immutablePush(screens, screen);
                    } else if (screen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_TARGET) {
                        screens = dataHelper.immutablePush(screens, screen);
                    }
                }
            } else {
                if (appHelper.isDefined(screen.parent_screen_id) && screen.parent_screen_id === value) {
                    if (this.state.bite.show_target_screens_in_menu && screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET) {
                        screens = dataHelper.immutablePush(screens, screen);
                    } else if (screen.screen_rule_type !== objectConstants.SCREEN_RULE_TYPE_TARGET) {
                        screens = dataHelper.immutablePush(screens, screen);
                    }
                }
            }
        }

        return screens;

        //TODO: change to simpler 1 line code once we know that parent_screen_id exists everywhere
        //return this.state.bite.screens.filter(obj => obj.parent_screen_id === value);
    }

    setMainMenuAnimation() {
        switch (this.props.displayMainMenu) {
            case actionTypes.STATUS_OPENING:
                this.showMenu();
                break;
            case actionTypes.STATUS_CLOSING:
                this.hideMenu();
                break;
            default:
                break;
        }
    }

    setMainMenuStatus() {
        switch (this.props.displayMainMenu) {
            case actionTypes.STATUS_OPENING:
                this.props.actions.setMainMenuDisplay(actionTypes.STATUS_OPEN);
                this.setInitialFocus();
                break;
            case actionTypes.STATUS_CLOSING:
                this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSED);
                break;
            default:
                break;
        }
    }

    showMenu() {
        let mainMenuPanel = this.mainMenu.current;
        if(appHelper.isEleDefined(mainMenuPanel)) {
            TweenLite.to(mainMenuPanel, objectConstants.DIALOG_DURATION, {

                delay: 0,
                ease: Expo.easeIn
            }).eventCallback("onComplete", this.setMainMenuStatus);
        }
    }

    hideMenu() {
        this.getClass();
        let mainMenuPanel = this.mainMenu.current;
        if(appHelper.isEleDefined(mainMenuPanel)) {
            TweenLite.to(mainMenuPanel, objectConstants.DIALOG_DURATION, {
                ease: Expo.easeIn
            }).eventCallback("onComplete", this.setMainMenuStatus);
        }
    }

    getClass() {
        if (this.props.displayMainMenu === actionTypes.STATUS_OPEN) {
            return "dialog-open";
        } else {
            return "dialog-closed";
        }
    }

    closeMenu() {
        let mainMenuBtn = document.getElementById("mainMenuBtn");

        setTimeout(function(){
            mainMenuBtn.focus();
        },1000);
        this.props.actions.setMainMenuDisplay(actionTypes.STATUS_CLOSING);
    }

    getHeaderClass() {

    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.closeMenu();
        }
    }

    onKeyDown(event) {
        let shiftPressed = this.state.shiftPressed;
        let tabPressed = this.state.tabPressed;

        if (event.which === keyboardConstants.ESCAPE_KEY) {

            event.preventDefault();
            this.closeMenu();
        }

        if (event.which === keyboardConstants.TAB_KEY) {

            tabPressed = true;
            this.setState({
                tabPressed: tabPressed
            });
        }

        if (event.which === keyboardConstants.SHIFT_KEY) {
            shiftPressed = true;
            this.setState({
                shiftPressed: shiftPressed
            });
        }
    }

    onKeyUp(event) {
        let activeItem = document.activeElement;
        let activeItemId = activeItem.id;
        if (activeItemId === this.state.tabbableElements[0].id) {
            //go to last
            this.state.tabbableElements[this.state.tabbableElements.length - 2].focus();
        } else if (activeItemId === this.state.tabbableElements[this.state.tabbableElements.length - 1].id) {
            this.state.tabbableElements[1].focus();
        }

        this.setState({
            tabPressed: false,
            shiftPressed: false
        });
    }

    setHeight(){
        this.setState({updateHeight: false});
        let screenWrapper = document.getElementById('screenWrapper');
        let header = document.getElementById('closeMenuBtn');
        if(appHelper.isDefined(header)){
            let newHeight = (screenWrapper.offsetHeight - header.offsetHeight);
            this.setState({height: newHeight});
        }
    }

    getHeight(){
        if(appHelper.isDefined(this.state.height)){
            return {
                height: `${this.state.height}px`,
                minHeight: `${this.state.height}px`,
            };
        }else{
            return {};
        }
    }

    render() {
        return (

            <div className={`dialog-page menu-page ${this.getClass()}`} ref={this.mainMenu} id="main-menu" role="dialog"
                 aria-modal={this.state.isDialog} aria-labelledby="main-menu">
                <div id={`firstTabIndex_mainMenu_${this.state.guid}`} tabIndex="0" role="button"/>
                <div className="content-dialog main-menu">

                    <div className="dialog-header guroo-dialog-header" onClick={this.closeMenu} ref="closeMenuBtn"
                         id="closeMenuBtn"
                         onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0">
                        <div className="main-menu-header">
                            <div className="left-col">
                                <div className="menu-title">
                                <div className="icons8-menu icon-first dialog-title">{this.state.main_menu_label}</div>
                                </div>
                                {
                                    Object.keys(localeStorage.localeOptions).length > 1 &&
                                    <div className="right-items">
                                        <Locale showTitle={this.state.showLocaleTitle}/>
                                    </div>
                                }
                            </div>
                            <div className="right-col">
                                <div className="left-items ">

                                    <div>
                                        <TextResizeTool/>
                                    </div>

                                    {(appHelper.isDefined(this.props.contentData.experience.home_position) && this.props.contentData.experience.home_position === navigationConstants.HOME_POSITION_IN_MENU) || !appHelper.isDefined(this.props.contentData.experience.home_position)
                                    ?
                                        localeStorage.bites.length > 1 && userDataHelper.getBiteStatus(this.props.userData.bites[0]) === objectConstants.STATUS_COMPLETE
                                            ?
                                            <div className="right-items ">
                                                <HomeBtn closeMenu={this.closeMenu}/>
                                            </div>
                                            :
                                            null
                                        :
                                        null
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="dialog-body" style={this.getHeight()}>
                        <div className="main-menu-nav" role="menu">
                            {this.state.screens.map(screen =>
                                !screen.hasChildren
                                    ?

                                    !this.state.bite.show_target_screens_in_menu || (this.state.bite.show_target_screens_in_menu && screen.screen_rule_type === objectConstants.SCREEN_RULE_TYPE_TARGET)
                                        ?
                                        <MainMenuItem
                                            key={screen.screen_id}
                                            screen={screen}
                                            className="list-group-item list-group-item-action"
                                        />
                                        : null

                                    : <MainMenuAccordionBtn key={screen.screen_id}
                                                            screen={screen}
                                                            className="list-group-item list-group-item-action"/>
                            )}
                        </div>
                        <div id={`lastTabIndex_mainMenu_${this.state.guid}`} tabIndex="0" role="button"/>
                    </div>
                </div>
            </div>

        );
    }

}

MainMenu.propTypes = {
    children: PropTypes.node,
    displayMainMenu: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    fontSize: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        displayMainMenu: state.displayMainMenu,
        userData: state.userData,
        contentData: state.contentData,
        trackingData: state.trackingData,
        fontSize: state.fontSize

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, mainMenuActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);


/** WEBPACK FOOTER **
 ** ./src/components/dialogs/mainMenu/MainMenu.js
 **/